import type { AnalyticsEnhancer } from '@analytics/models';
import type { Type } from '@angular/core';
import { ANALYTICS_ENHANCERS } from './analytics-enhancer';

export function provideEnhancers(enhancers: Type<AnalyticsEnhancer>[]) {
  return {
    provide: ANALYTICS_ENHANCERS,
    deps: enhancers,
    useFactory: (...instances: AnalyticsEnhancer[]) => instances,
  };
}
